module.exports = __webpack_public_path__ + "static/media/python.a271499c.svg";